import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { Opendistributionbutton, Organization } from "../../../../studio/sanity.types";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import { WidgetContext } from "../../layout/layout";
import { PrefilledDistribution } from "../../layout/WidgetPane/WidgetPane";
import styles from "./OpenDistributionButton.module.scss";
import { usePlausible } from "next-plausible";
export const OpenDistributionButton: React.FC<Opendistributionbutton> = t0 => {
  const $ = _c(18);
  const {
    text,
    inverted,
    organization,
    display_output_info,
    distribution_cause_areas
  } = t0;
  const [, setWidgetContext] = useContext(WidgetContext);
  const plausible = usePlausible();
  if (!distribution_cause_areas) {
    return null;
  }
  const resolvedOrganization = organization && organization._type !== "reference" ? organization as unknown as Organization : null;
  let t1;
  if ($[0] !== distribution_cause_areas) {
    t1 = cleanDistribution(distribution_cause_areas);
    $[0] = distribution_cause_areas;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const prefilled = t1;
  let containerStyles;
  if ($[2] !== inverted) {
    containerStyles = [styles.container];
    if (inverted) {
      containerStyles.push(styles.inverted);
    }
    $[2] = inverted;
    $[3] = containerStyles;
  } else {
    containerStyles = $[3];
  }
  const t2 = containerStyles.join(" ");
  let t3;
  if ($[4] !== display_output_info || $[5] !== resolvedOrganization) {
    t3 = display_output_info && resolvedOrganization && <div className={styles.outputInfo}><h2>{resolvedOrganization.invervention_cost}</h2><span>{resolvedOrganization.intervention_effect}</span></div>;
    $[4] = display_output_info;
    $[5] = resolvedOrganization;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== plausible || $[8] !== prefilled || $[9] !== setWidgetContext) {
    t4 = () => {
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      plausible("OpenDonationWidgetPrefilledDistributionCTA", {
        props: {
          page: window.location.pathname
        }
      });
      setWidgetContext({
        open: true,
        prefilled,
        prefilledSum: null
      });
    };
    $[7] = plausible;
    $[8] = prefilled;
    $[9] = setWidgetContext;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4 || $[12] !== text) {
    t5 = <div className={styles.buttonContainer}><EffektButton onClick={t4}>{text}</EffektButton></div>;
    $[11] = t4;
    $[12] = text;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};

// Type guards to help TypeScript understand our filtered types
type ValidCauseArea = {
  cause_area_id: number;
  cause_area_percentage: number;
  cause_area_organizations?: Array<{
    organization_id?: number;
    organization_percentage?: number;
    _key: string;
  }>;
  _key: string;
};
type ValidOrganization = {
  organization_id: number;
  organization_percentage: number;
  _key: string;
};
export const cleanDistribution = (input: Opendistributionbutton["distribution_cause_areas"]): PrefilledDistribution => {
  if (!input) {
    return [];
  }
  return input.filter((area): area is ValidCauseArea => area != null && typeof area.cause_area_id === "number" && typeof area.cause_area_percentage === "number").map(area => ({
    causeAreaId: area.cause_area_id,
    share: area.cause_area_percentage,
    organizations: (area.cause_area_organizations ?? []).filter((org): org is ValidOrganization => org != null && typeof org.organization_id === "number" && typeof org.organization_percentage === "number").map(org => ({
      organizationId: org.organization_id,
      share: org.organization_percentage
    }))
  }));
};